export const formatDateTime = (dateString, includeTime = true) => {
  if (!dateString) return "";

  // Заменяем тире на косую черту для поддержки Safari
  const normalizedDateString = dateString.replace(/-/g, '/');

  const dateObj = new Date(normalizedDateString);
  if (isNaN(dateObj.getTime())) return ""; // Проверка на валидность даты

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();

  if (!includeTime) {
    return `${day}.${month}.${year}`;
  }

  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");

  return `${day}.${month}.${year} ${hours}:${minutes}`;
};